import React, {Component} from 'react'

class IconFolder extends Component {
    render(){
        return (
            <>
                <svg style={this.props.style||{}} t="1715053233246" className="icon" viewBox="0 0 1513 1024" version="1.1"
                     xmlns="http://www.w3.org/2000/svg" p-id="2557" width={this.props.width||20+'px'} height={this.props.width||20+'px'}>
                    <path
                        d="M1333.835122 128.00032h-549.115882a63.99952 63.99952 0 0 1-45.439659-18.559861L649.040258 18.561141A63.99952 63.99952 0 0 0 603.600598 0.00128H181.843762a63.99952 63.99952 0 0 0-63.99952 63.99952v895.99328a63.99952 63.99952 0 0 0 63.99952 63.99952h1151.99136a63.99952 63.99952 0 0 0 63.99952-63.99952V191.99984a63.99952 63.99952 0 0 0-63.99952-63.99952z m-1151.99136 0V64.0008h412.796904l63.99952 63.99952z"
                        fill="#1967D2" p-id="2558"></path>
                    <path
                        d="M1449.674253 296.319058H780.879269a63.99952 63.99952 0 0 1-40.319698-14.079895l-92.799304-76.159429A63.99952 63.99952 0 0 0 607.44057 191.99984H64.72464a63.99952 63.99952 0 0 0-63.99952 73.599448l108.159189 703.99472a63.99952 63.99952 0 0 0 63.99952 54.399592H1344.71504a63.99952 63.99952 0 0 0 63.99952-53.119602l104.319218-599.675502a63.99952 63.99952 0 0 0-63.359525-74.879438z"
                        fill="#4C9AFF" p-id="2559"></path>
                </svg>
            </>
        )
    }
}
export default IconFolder